import { render, staticRenderFns } from "./model.image.vue?vue&type=template&id=5a957174&"
import script from "./model.image.vue?vue&type=script&lang=ts&"
export * from "./model.image.vue?vue&type=script&lang=ts&"
import style0 from "./model.image.vue?vue&type=style&index=0&id=5a957174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports